import { Collection } from '@/state/Collection';
import { _REWARDS } from "@/state";
import { ModelDefaults } from "@/state/ModelDefaults";

import { RewardsRoutes } from '@/repository/resources';
const { GetAllRewards, PingRewards, GetReward, CreateReward, UpdateReward, DeleteReward } = RewardsRoutes;

// Export this module
export default {
	namespaced: true,
	state: {
		all: Collection.stateDefaults(),
		_all: new Collection({ statePath: 'rewards.all', autoSortRule: { key: 'coins_needed', asc: false } })
	},
	actions: {

		async index({ commit }, args) {
			try {
				let { page, type, per_page, show_disabled } = Object.assign({}, args)
				let res = await GetAllRewards({ page, type, per_page, show_disabled });
				return res.data;
			}
			catch (error) {
				console.error('Rewards could not be indexed.', error);
				throw error;
			}
		},

		async ping() {
			try {
				let res = await PingRewards();
				return res.data;
			}
			catch (error) {
				console.error('Could not ping rewards.', error);
				throw error;
			}
		},

		async indexNextPage({ commit }) {
			try {
				if (_REWARDS().pagination.isLastPage()) {
					return;
				}
				let res = await GetAllRewards({ page: _REWARDS().pagination.nextPage() })
				commit('APPEND_MULTIPLE_REWARDS_TO_LIST', res.data);
			}
			catch (error) {
				console.error('Next page of rewards could not be indexed.', error);
				throw error;
			}
		},

		async show({ }, { id }) {
			try {
				let res = await GetReward({ reward: id });
				return res.data
			}
			catch (error) {
				console.error('Reward could not be shown.', error);
				throw error;
			}
		},

		async createOrUpdate({ commit }, { reward }) {
			try {
				let res = {}
				if (reward.id) {
					res = await UpdateReward({ reward });
				}
				else {
					res = await CreateReward({ reward });
				}
				return res
			}
			catch (error) {
				console.error('Reward could not be created/updated.', error);
				throw error;
			}
		},

		async delete({ commit }, { reward }) {
			try {
				let res = await DeleteReward({ reward });
				if (res.status !== 204) {
					throw 'Problem occurred when deleting reward.';
				}
				commit('DELETE_REWARD', reward)
				return true;
			}
			catch (error) {
				console.error('Reward could not be deleted.', error);
				throw error;
			}
		},

		async showEmpty({ }) {
			return await ModelDefaults.Reward()
		}

	},
	mutations: {
		SET_REWARDS_LIST(state, data) {
			state._all.items.set(data).commitToState()
		},
		APPEND_MULTIPLE_REWARDS_TO_LIST(state, objs) {
			state._all.items.appends(objs).commitToState();
		},
		APPEND_SINGLE_REWARD_TO_LIST(state, obj) {
			state._all.items.append(obj).commitToState();
		},
		UPDATE_REWARD(state, obj) {
			state._all.items.updateItem(obj).commitToState();
		},
		DELETE_REWARD(state, obj) {
			state._all.items.deleteItem(obj).commitToState();
		},

	}
}